module.exports = __webpack_public_path__ + "img/xinwenguanli.05d7c487.png";